﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs, eBundle } from "@app/helpers/dirs";

export interface ISvgViewerScope extends ng.IScope {
    ngModel: string;
    _html: string;
    defs: string;
    height: number;
    width: number;
    /**
     * Mouse events provide means to customize behavior when dragging or clicking.
     * */
    kbDragStart: (obj: any) => void;
    kbDragEnd: (obj: any) => void;
    kbDragMove: (obj: any) => void;
    mouseWheel: (e: JQueryEventObject) => void;
    kbClick: (obj: any) => void;

    maxZoom: number;
    minZoom: number;
    disablePan: boolean;
    disableZoom: boolean;
    zoomLevel: number;
    panX: number;
    panY: number;

    svg: any;
    svgStyle: string;

    svgWidth: string;
    svgHeight: string;
}
/**
 * Given markdown text in the ngModel, will display the html
 */
@NgComponent({
    token: Token.KbSvgViewer,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbSvgViewer extends Directive {
    constructor($timeout: ng.ITimeoutService) {
        super();
        this.scope = {
            ngModel: "=",
            width: "=?",
            height: "=?",
            svgWidth: "=?",
            svgHeight: "=?",
            svgStyle: "=?",
            kbDragStart: "&",
            kbDragMove: "&",
            kbDragEnd: "&",
            kbClick: "&",
            defs: "=?",
            maxZoom: "=?",
            minZoom: "=?",
            disablePan: "=?",
            disableZoom: "=?",
            zoomLevel: "=?",
            panX: "=?",
            panY: "=?"
        };

        this.restrict = "E";
        this.template = Dirs.component("kb-svg-viewer", eBundle.app);
        this.replace = true;
        this.require = "ngModel";
        this.transclude = true;

        

        this.link = (scope: ISvgViewerScope, element: JQuery, atts, ngModel: ng.INgModelController) => {

            scope.svg = { width: "0", height: "0" };
            if (!scope.svgStyle) scope.svgStyle = "";

            if (!scope.minZoom) scope.minZoom = 0.124;
            if (!scope.maxZoom) scope.maxZoom = 4;
            if (!scope.zoomLevel) scope.zoomLevel = 1;
            if (!scope.panX) scope.panX = 0;
            if (!scope.panY) scope.panY = 0;

            const tolerance = 10;

            let isDown = false;
            let dragged = false;
            let dragOriginX = 0;
            let dragOriginY = 0;
            let baseMouse;

            let svg = element.find("svg");
            let g = svg.find("g");

            let svgDims = {
                width: 0,
                height: 0,
                scale: scope.zoomLevel,
                scrollX: scope.panX,
                scrollY: scope.panY
            };

            let svgWidthIsAuto = () => !scope.svgWidth || scope.svgWidth == "auto";

            let svgHeightIsAuto = () => !scope.svgHeight || scope.svgHeight == "auto";

            if (!svgWidthIsAuto()) {
                svgDims.width = parseFloat(scope.svgWidth);
            }
            if (!svgHeightIsAuto()) {
                svgDims.height = parseFloat(scope.svgHeight);
            }
            
            scope.$watch("zoomLevel", (level: number) => {

                svgDims.scale = level;

                svgDims.scale = Math.min(Math.max(scope.minZoom, svgDims.scale), scope.maxZoom);

                updateSvg();
            });

            scope.$watch("panX", (x: number) => {

                svgDims.scrollX = x;

                svgDims.scrollX = Math.min(Math.max(-svg.outerWidth() * svgDims.scale, svgDims.scrollX), svg.outerWidth() * svgDims.scale);

                updateSvg();
            });

            scope.$watch("panY", (y: number) => {

                svgDims.scrollY = y;

                svgDims.scrollY = Math.min(Math.max(-svg.outerHeight() * svgDims.scale, svgDims.scrollY), svg.outerHeight() * svgDims.scale);

                updateSvg();
            });

            let getEvent = (e: MouseEvent) => {
                let svgWidth = svg.outerWidth();
                let svgHeight = svg.outerHeight();

                let modifierX = svgDims.width / svgWidth;
                let modifierY = svgDims.height / svgHeight;

                let event = {
                    offsetX: e.offsetX * modifierX + svgDims.scrollX * modifierX,
                    offsetY: e.offsetY * modifierY + svgDims.scrollY * modifierY,
                    target: e.target,
                    currentTarget: e.currentTarget
                }
                return event;
            };

            let updateSvg = (recalculateSize: boolean = true) => {

                if (recalculateSize) {
                    if (svgWidthIsAuto()) {
                        svgDims.width = 0;
                    }
                    else {
                        svgDims.width = (parseInt(scope.svgWidth));
                    }
                    if (svgHeightIsAuto()) {
                        svgDims.height = 0;
                    }
                    else {
                        svgDims.height = (parseInt(scope.svgHeight));
                    }

                    g.children().each(function () {
                        let thisEl = (<any>jQuery(this)[0]);
                        if (thisEl.getBBox) {
                            let bbox = thisEl.getBBox();
                            let xPos = (bbox.x + bbox.width);
                            let yPos = (bbox.y + bbox.height);

                            if (svgWidthIsAuto()) {
                                if (xPos > svgDims.width) svgDims.width = xPos;
                            }
                            if (svgHeightIsAuto()) {
                                if (yPos > svgDims.height) svgDims.height = yPos;
                            }
                        }
                    });
                }

                scope.svg.width = svgDims.width * svgDims.scale;
                scope.svg.height = svgDims.height * svgDims.scale;

                let render = () => {
                    g.attr("transform", `scale(${svgDims.scale}, ${svgDims.scale})`);
                    //element.scrollLeft(svgDims.scrollX);
                    //element.scrollTop(svgDims.scrollY);

                    let svgWidth = svg.outerWidth();
                    let svgHeight = svg.outerHeight();

                    let modifierX = svgDims.width / svgWidth;
                    let modifierY = svgDims.height / svgHeight;

                    let viewBoxX = (svgDims.scrollX * modifierX);
                    let viewBoxY = (svgDims.scrollY * modifierY);

                    if (!isNaN(viewBoxX) && !isNaN(viewBoxY)) {
                        svg.attr("viewBox", viewBoxX + " " + viewBoxY + " " + svgDims.width + " " + svgDims.height);
                    }
                };

                render();
                if (recalculateSize) {
                    render();
                }

                $timeout(() => scope.$digest());
            }

            let onMousedown = (e: PointerEvent) => {
                isDown = true;
                scope.kbDragStart({ $event: getEvent(e) });
                baseMouse = {
                    x: e.screenX + svgDims.scrollX,
                    y: e.screenY + svgDims.scrollY
                };
            };

            let onMouseup = (e: PointerEvent) => {
                scope.kbDragEnd({ $event: getEvent(e) });
                if (!dragged) {

                    let inSvg = false;
                    let el = (<any>e.target);
                    while (el) {
                        if (el.tagName == "svg") {
                            inSvg = true;
                            break;
                        }
                        el = el.parentElement;
                    }

                    if (inSvg) {
                        scope.kbClick({ $event: getEvent(e) });
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
                else {
                    e.preventDefault();
                    e.stopPropagation();
                }
                isDown = dragged = false;
            };

            let onMousemove = (e: PointerEvent) => {
                if (isDown) {
                    scope.kbDragMove({ $event: getEvent(e) });
                    if (!scope.disablePan) {
                        scope.panX = svgDims.scrollX = (baseMouse.x - e.screenX);
                        scope.panY = svgDims.scrollY = (baseMouse.y - e.screenY);
                        updateSvg(false);
                    }
                    let diff = Math.sqrt(Math.abs(((baseMouse.x - e.screenX) ^ 2) + ((baseMouse.y - e.screenY) ^ 2)));
                    if (diff > tolerance) dragged = true;
                }
            };

            let onWheel = (event: WheelEvent) => {
                event.preventDefault();

                if (scope.disableZoom) return;

                let difference = 1;
                if (event.deltaY < 0) {
                    difference = 1.05;
                }
                else {
                    difference = 0.95;
                }

                let oldZoom = svgDims.scale;

                svgDims.scale *= difference;
                scope.zoomLevel = svgDims.scale;

                svgDims.scale = Math.min(Math.max(scope.minZoom, svgDims.scale), scope.maxZoom);

                let zoom = svgDims.scale;

                let scalechange = zoom - oldZoom;

                scope.panX = svgDims.scrollX = svgDims.scrollX + (event.offsetX * scalechange);
                scope.panY = svgDims.scrollY = svgDims.scrollY + (event.offsetY * scalechange);

                //window.console.log(svgDims.scrollX + ", " + svgDims.scrollY);

                updateSvg(false);
            };

            ngModel.$render = () => { // called when the binding has been changed by the consumer
                let v:string = ngModel.$viewValue;
                if (!v) v = "";
                v = v.replace(/url\((#[^\)]*)\)/g, "url(" + location.href + "$1)");
                scope._html = v;// $v[0].innerHTML;// v? md.Transform(v): null;

                setTimeout(updateSvg, 1);
            };

            element[0].addEventListener("pointerdown", onMousedown);
            document.addEventListener("pointerup", onMouseup);
            element[0].addEventListener("pointermove", onMousemove);
            element[0].addEventListener("wheel", onWheel);

            scope.$on("$destroy", () => {
                element[0].removeEventListener("pointerdown", onMousedown);
                document.removeEventListener("pointerup", onMouseup);
                element[0].removeEventListener("pointermove", onMousemove);
                element[0].removeEventListener("wheel", onWheel);
            });
        };
    }
}
